import DatepickerRange, {
  DatepickerRangeProps,
} from "domains/ui/components/Datepicker";

export interface FmHeaderFilterDateProps extends DatepickerRangeProps {}

export default function FmHeaderFilterDate(props: FmHeaderFilterDateProps) {
  return <DatepickerRange {...props} />;
}
